export enum GRID {
  /* Mobile */
  _XS = '(max-width: 750px)',
  /* Tablets */
  _SM = '(min-width: 768px) and (max-width: 1279px)',
  /* Desktop */
  _LG = '(min-width: 1280px) and (max-width: 1439px)',
  /* Extra Screens */
  _XL = '(min-width: 1440px)',
}
